export default {
    // TODO: add settings to remove here.
};



// WEBPACK FOOTER //
// ./settings/remove.ts